import React from 'react';
import axios from 'axios';
import "./Header"

import './App.css';
import Header from './Header';
import VisitorCount from './VisitorCount';

class App extends React.Component {
  state = {
    advice: '',
  }

  componentDidMount() {
    this.fetchAdvice();
  }

  fetchAdvice = () => {
    axios.get('https://api.adviceslip.com/advice')
      .then((response) => {
        const { advice } = response.data.slip;

        this.setState({ advice });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
     <React.Fragment>
     <div className="app">
       <Header/>
        <div className="card">
          <h1 className="heading">{this.state.advice}</h1>
          <button className="button" onClick={this.fetchAdvice}>
            <span>GIVE ME ADVICE!</span>
          </button>
        </div>
        <VisitorCount/>
      </div>
      </React.Fragment>
      
    );
  }
}

export default App;